import React, { Component } from 'react'; 
import {Row , Col, Button} from 'react-bootstrap';
import ModalForm from './ModalForm';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; 

export default class Csatform extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      createForm:false,
    }
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.find(inventory);
      this.setState({selectedregionName:regionNames})
      }  
  }
  componentWillReceiveProps(nextProps){
    if(this.state.createForm === true && !_.isEmpty(nextProps.csattemplate) 
      && !_.isEqual(this.props.csattemplate && nextProps.csattemplate)){
      this.calleddModalForm(nextProps.csattemplate)
    }
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){    
        let centerName = _.filter(selectedregionName.userCenters);
        return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    const{inventory} = this.props;
     if(!_.isEmpty(inventory)){
       let clientName = _.filter(selectedcenterName.userClients);
       return clientName;
    }
  }
 
  
  handleSelect = (e) => {
    this.setState({selectedregionName: e} );
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedclientName:[], selectedcenterName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});    
    this.props.function.resetTemplate()
  }  
  closeModal = () => {
    this.setState({'createForm':false})
    this.props.function.ResetUserData()   
  }
  validateForm = () =>{    
    const {selectedclientName,selectedcenterName} = this.state;
      if(!_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName)){
        return true }
  }
  valueReturn = () => {
    let retunOBj = [];
    if(!_.isEmpty(this.state.selectedclientName)){
      retunOBj = _.find(this.state.selectedclientName.userProcesses, {inventoryProcessName: "CSAT"}) ?
      {'inventoryProcessName':'CSAT'} : ['No CSAT Process Mapped']
    }
    return retunOBj
  }
  createFormCSAT = () => {      
    const {selectedclientName,selectedcenterName, selectedregionName} = this.state;
    let x;
    let process = _.find(this.props.inventoryCsat.processes, {label: "CSAT"})
    if(!_.isEmpty(process)){
       x = {'processId':process.id, "processName":process.label}
    } else {
      x = {'processId':"", "processName":""}
    }
    this.setState({'createForm':true}) 
    let obj = {
    region:{'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
    center:[{'centerId':selectedcenterName.inventoryCenterId, 'centerName':selectedcenterName.inventoryCenterName}], 
    client:[{'clientId':selectedclientName.inventoryClientId, 'clientName':selectedclientName.inventoryClientName}], 
    process:[x],
    auditType:"CSAT Audit"
    }
    this.props.function.TokenValidation()     
    this.props.function.actionSearchTemplate(obj)
  }
  calleddModalForm = (prop) =>{
    const {selectedclientName,selectedcenterName, selectedregionName} = this.state;
    if(!_.isEmpty(prop)){    
    return(
      <ModalForm closeModal={this.closeModal} template={prop}
      region={{'inventoryRegionId':selectedregionName.inventoryRegionId, 'inventoryRegionName':selectedregionName.inventoryRegionName}}
      center={{'inventoryCenterId':selectedcenterName.inventoryCenterId, 'inventoryCenterName':selectedcenterName.inventoryCenterName}} 
      client={ {'inventoryClientId':selectedclientName.inventoryClientId, 'inventoryClientName':selectedclientName.inventoryClientName}} 
      process={{'inventoryProcessId':'', "inventoryProcessName":'CSAT'}}
      loginUserName ={this.props.loginUserName}
      function={this.props.function} csatuserData={this.props.csatuserData}/>
    )
    }
  }
  
 
   render(){
     return(<div className=''>
     <Row>
       <Col>
         <label>Region Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedregionName}
         options={this.regionNames()}
         onChange={this.handleSelect}
         open={false}
         valueKey="inventoryRegionName"
         labelKey="inventoryRegionName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Region'
         dropdownHeight={600}
       />
       </Col>
     </Row> 
     <Row>
       <Col>
         <label>Center Name</label>
       </Col>
       <Col>
       <Picky keepOpen={false}
         value={this.state.selectedcenterName}
         options={this.centerNames()}
         onChange={this.handleSelectCenter}
         open={false}
         valueKey="inventoryCenterName"
         labelKey="inventoryCenterName"
         multiple={false}
         includeSelectAll={false}
         includeFilter={true}
				 clearFilterOnClose={true}
         placeholder='Select Center'
         dropdownHeight={600}
       />
       </Col>             
     </Row>
     <Row>
     <Col>
     <label>Client Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
       value={this.state.selectedclientName}
       options={this.clientNames()}
       onChange={this.handleSelectClient}
       open={false}
       valueKey="inventoryClientName"
       labelKey="inventoryClientName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Client'
       dropdownHeight={600}
     />
     </Col>
     </Row> 
     <Row>
     <Col>
     <label>Process Name</label>
     </Col>
     <Col>
     <Picky keepOpen={false}
      value={this.valueReturn()}
      // options={this.processNames()}
      // onChange={this.handleSelectProcess}
       open={false}
       valueKey="inventoryProcessName"
       labelKey="inventoryProcessName"
       multiple={false}
       includeSelectAll={false}
       includeFilter={true}
       clearFilterOnClose={true}
       placeholder='Select Process Name'
       dropdownHeight={600}
       disabled
     />
      </Col>
      </Row>     
       <br/>
       <center><Button className='buttonwidth' size='md'
       onClick={this.createFormCSAT} disabled={!this.validateForm()} >Audit</Button></center>
       {(this.state.createForm) ?
          this.calleddModalForm(this.props.csattemplate)       
       : null
       } 
       
 </div>)
   }
  }    
